const BASE_URL = import.meta.env.VITE_REACT_APP_BASE_URL
const createURL = (path) => `${BASE_URL}/${path}`

// auth
export const SIGNUP_URL = createURL("signup")
export const SIGNIN_URL = createURL("login")
export const FORGOT_PASSWORD = createURL("forgot-password")
export const VERIFY_TOKEN_PASSWORD_URL = createURL("verify-token-password")
export const RESET_PASSWORD_URL = createURL("reset-password")
export const LOGOUT_URL = createURL("logout")
export const PROTECTED_URL = createURL("protected")

export const ORDER_INITIATE_URL = createURL("order-initiate")
export const ORDER_VERIFY_URL = createURL("order-verify")
export const UPDATE_SCORE_URL = createURL("updateScore")

export const GET_OWN_DETAILS = createURL("getOwnDetail")
